import { render, staticRenderFns } from "./TaskDetial.vue?vue&type=template&id=148bef59&scoped=true"
import script from "./TaskDetial.vue?vue&type=script&lang=js"
export * from "./TaskDetial.vue?vue&type=script&lang=js"
import style0 from "./TaskDetial.vue?vue&type=style&index=0&id=148bef59&prod&lang=scss&scoped=true"
import style1 from "./TaskDetial.vue?vue&type=style&index=1&id=148bef59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148bef59",
  null
  
)

export default component.exports